function getStatusCode(err: unknown): number | undefined {
  if (!err || typeof err !== 'object') return undefined;
  const meta = (err as { meta?: { statusCode?: number } }).meta;
  if (typeof meta?.statusCode === 'number') return meta.statusCode;
  const response = (err as { response?: { status?: number } }).response;
  if (typeof response?.status === 'number') return response.status;
  const status = (err as { status?: number }).status;
  if (typeof status === 'number') return status;
  return undefined;
}

// Hide BE message for 500 — it's typically a generic "Internal Server Error"
// or a stack trace that isn't actionable. Other 5xx (502/503/504) often carry
// meaningful messages from upstream services, so surface those.
export function extractError(err: unknown, fallback = 'An unexpected error occurred'): string {
  const status = getStatusCode(err);
  if (status === 500) return fallback;

  if (err && typeof err === 'object' && 'error' in err) {
    const apiErr = err as { error?: { message?: string } };
    if (apiErr.error?.message) return apiErr.error.message;
  }
  if (err instanceof Error) return err.message;
  return fallback;
}

// The BE guards AI-dependent endpoints and rejects with
// { error: { code: 'ONBOARDING_INCOMPLETE', message: 'Onboarding incomplete...' } }
// while onboarding/automation hasn't finished. Accepts either the raw
// rejection or an already-extracted message string, since stores only keep
// the string (LIL-440).
export function isOnboardingIncompleteError(err: unknown): boolean {
  if (typeof err === 'string') return /onboarding incomplete/i.test(err);
  if (err && typeof err === 'object' && 'error' in err) {
    const detail = (err as { error?: { code?: string; message?: string } }).error;
    if (detail?.code === 'ONBOARDING_INCOMPLETE') return true;
    if (detail?.message && /onboarding incomplete/i.test(detail.message)) return true;
  }
  return err instanceof Error && /onboarding incomplete/i.test(err.message);
}
